import { createContext } from "react";
import { SiteType } from "../types/api";
import { useContext } from "react";

export interface PageWithSite {
  site: SiteType;
  reload: () => Promise<void>;
}

const CurrentSiteContext = createContext<PageWithSite>({
  // @ts-ignore
  site: undefined,
  reload: async () => {},
});

export const ProvideSite = ({ children, site, reload }: any) => {
  return (
    <CurrentSiteContext.Provider value={{ site, reload }}>
      {children}
    </CurrentSiteContext.Provider>
  );
};

export const useSiteState = () => {
  return useContext(CurrentSiteContext);
};
